import { NavLink } from '.'

export const defaultNavlinks: Array<NavLink> = [
    {
        label: 'Dashboard',
        faicon: 'fas fa-th-large',
        href: '/dashboard-new',
        isHeader: false
    },
    {
        label: 'Cart',
        faicon: 'fas fa-shopping-cart',
        href: '/cart',
        isHeader: false
    },
    {
        label: 'My Orders',
        faicon: 'fak fa-my-orders',
        href: '/my-orders',
        isHeader: false
    },
    {
        label: 'My Groups',
        faicon: 'fak fa-my-groups',
        href: '/groups',
        isHeader: false
    },
    {
        label: 'My Achievements',
        faicon: 'fas fa-award',
        href: '/achievements',
        isHeader: false
    },
    {
        label: 'Social',
        faicon: 'fas fa-users',
        href: '/social',
        isHeader: false
    },
    {
        label: 'My Profile',
        faicon: 'fas fa-user',
        href: '/profile',
        isHeader: false
    },
    {
        label: 'Fitness',
        faicon: null,
        href: null,
        isHeader: true
    },
    {
        label: 'Races',
        faicon: 'fak fa-yf-race',
        href: '/races',
        isHeader: false
    },
    {
        label: 'Exercises',
        faicon: 'fas fa-running',
        href: '/exercises',
        isHeader: false
    },
    {
        label: 'Challenges',
        faicon: 'fak fa-yf-challenge',
        href: '/challenges',
        isHeader: false
    },
    {
        label: 'Store',
        faicon: 'fak fa-yf-store',
        href: '/store',
        isHeader: false
    },
    // {
    //     label: 'Trainers/Coaches',
    //     faicon: 'whistle',
    //     href: '/trainers',
    //     isHeader: false
    // },
    // {
    //     label: 'Classes',
    //     faicon: 'play',
    //     href: '/classes',
    //     isHeader: false
    // },
    {
        label: 'Yes.Fit Links',
        faicon: null,
        href: null,
        isHeader: true
    },
    {
        label: 'Gift Cards',
        faicon: 'fas fa-gift-card',
        href: '/gift',
        isHeader: false
    },
    {
        label: 'FAQ',
        faicon: 'fas fa-question-circle',
        href: 'https://help.yes.fit/en/',
        isHeader: false
    },
    {
        label: 'Community',
        faicon: 'fak fa-community',
        href: '/community',
        isHeader: false
    },
    {
        label: 'Corp Wellness',
        faicon: 'fas fa-building',
        href: '/corporate-wellness',
        isHeader: false
    },
    {
        label: 'Membership',
        faicon: 'fas fa-certificate',
        href: '/membership',
        isHeader: false
    },
    {
        label: 'Blog',
        faicon: 'fas fa-newspaper',
        href: '/blog',
        isHeader: false
    },
    // {
    //     label: 'About us',
    //     faicon: 'fas fa-question-circle',
    //     href: '/about-us',
    //     isHeader: false
    // },
    // {
    //     label: 'Help and Support',
    //     faicon: 'fas fa-headset',
    //     href: '/help',
    //     isHeader: false
    // },
    {
        label: 'Privacy Policy',
        faicon: 'fak fa-yf-policy',
        href: 'https://races.yes.fit/privacy-policy',
        isHeader: false
    },
    {
        label: 'Terms and Conditions',
        faicon: 'fak fa-yf-terms',
        href: '/terms',
        isHeader: false
    }
]
